import styled from 'styled-components';

export const AppWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;
  padding-bottom: 24px;
`;

export const HelloMessage = styled.h2`
  margin-right: auto;
  margin-left: auto;
  color: #3f51b5;
`;
